export enum CompanyStatus{
    Enable= "enable",
    Disable = "disable" 
}
export interface Company{
    _id: string
    name: string
    status: CompanyStatus
    rootCompany: boolean
}